import { render, staticRenderFns } from "./rangeRule.vue?vue&type=template&id=3bdb46c1&scoped=true&"
import script from "./rangeRule.vue?vue&type=script&lang=js&"
export * from "./rangeRule.vue?vue&type=script&lang=js&"
import style0 from "./rangeRule.vue?vue&type=style&index=0&id=3bdb46c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdb46c1",
  null
  
)

export default component.exports